<app-dialog-overlay (closed)="closeDialog()">
  <div class="ui-dialog-card">
    <p class="ui-page-subtitle mb-5">
      {{ "copy_to_clipboard.copy_title" | translate }}
    </p>

    <div
      class="border p-3 mt-2.5 rounded bg-gray-100 share-message"
      contenteditable="true"
    >
      {{ messageComplete }}
    </div>

    <div class="mt-2.5">
      <app-button (click)="copyToClipboard()">
        <p>{{ "copy_to_clipboard.copy-to-clipboard" | translate }}</p>
      </app-button>
    </div>
  </div>
</app-dialog-overlay>
